import React from "react";
import './SlideOutBar.scss'


const formatDate = (date) => {	
	
	const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    var d = date,
        month = '' + (d.getMonth()),
        day = '' + d.getDate(),
        year = d.getFullYear();

    return `${monthNames[month]} ${day}, ${year}`;
}
export function SlideOutBar({currentLocation, setCurrentLocation}) {	
  return(
  	<div className={currentLocation ? "SlideOutBar" : "SlideOutBar hide"}>
		{currentLocation ? (		
			<div className="px-5 py-5 mb-5">			
				<div className="text-right w-full">
				<button onClick={() => {setCurrentLocation(null)}} className="back-arrow pb-4 ">
					<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fillRule="evenodd" clipRule="evenodd" d="M0 6.86904L6.86904 0L8.48528 1.61624L4.38727 5.71425H16V7.99997H4.47342L8.72796 12.2545L7.11171 13.8707L1.67125 8.43028L1.61624 8.48528L0 6.86904Z" fill="white"/>
					</svg>
				</button>
				</div>
				<p>{formatDate(currentLocation.date_obj)}</p>
				<h3 className="h3">{currentLocation.type} Incident</h3>
				<hr className="dotted my-5"/>
				<div className="locate-box">
					{currentLocation.locate_requested === 'y' ? <span>
						<svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.0315 0.316974C14.1298 0.216616 14.2472 0.136889 14.3768 0.0824619C14.5063 0.0280345 14.6455 0 14.786 0C14.9265 0 15.0656 0.0280345 15.1952 0.0824619C15.3247 0.136889 15.4421 0.216616 15.5405 0.316974C15.9526 0.733487 15.9584 1.40654 15.5549 1.83026L7.03292 11.9044C6.93616 12.0106 6.81875 12.096 6.68786 12.1553C6.55697 12.2147 6.41535 12.2466 6.27167 12.2493C6.128 12.252 5.98528 12.2254 5.85226 12.171C5.71923 12.1167 5.59869 12.0358 5.49802 11.9332L0.312501 6.67853C0.112513 6.47457 0.000488281 6.20032 0.000488281 5.91468C0.000488281 5.62904 0.112513 5.35478 0.312501 5.15083C0.410859 5.05047 0.52825 4.97075 0.657801 4.91632C0.787353 4.86189 0.926461 4.83386 1.06698 4.83386C1.2075 4.83386 1.34661 4.86189 1.47616 4.91632C1.60571 4.97075 1.7231 5.05047 1.82146 5.15083L6.22007 9.60853L14.0027 0.348681C14.0116 0.337542 14.0213 0.326954 14.0315 0.316974Z" fill="#8BDA00"/></svg>
						Locate Requested</span> : <span>No Locate Requested</span>}
				</div>
				<div className="mt-5">
					<strong>Facility Damaged: </strong>
					<p>{currentLocation.fac_damage} {currentLocation.fac_affected}</p>
				</div>
				<div className="my-5">
					<strong>Excavation Type:</strong>
					<p>{currentLocation.exc_type}</p>
				</div>
			</div>
		): <></>}
	</div>
  )
}